import { Spreadsheet } from '@/components/spreadsheet/spreadsheet';

export class SpreadsheetComposer extends Spreadsheet {
  name: string;

  constructor(name: string) {
    super();
    this.name = name;
  }

  mount (sheets: any) {
    this.workbookOptions = {
      sheets
    };

    return this;
  }
}
